import React, { useState } from 'react';
import { motion } from 'framer-motion';
import './App.css';

function App() {
  const currentYear = new Date().getFullYear();
  const [isAboutVisible, setIsAboutVisible] = useState(false);

  return (
    <div className="App">
      <motion.div 
        className="page-wrapper"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        <motion.div className="header-section">
          <motion.img
            src={`${process.env.PUBLIC_URL}/assets/logo.png`}
            alt="ForWhileDo Logo"
            className="header-logo"
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.7, delay: 0.2, ease: "easeOut" }}
          />
          <motion.button
            className="about-button"
            onClick={() => setIsAboutVisible(true)}
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.7, delay: 0.3, ease: "easeOut" }}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            About
          </motion.button>
        </motion.div>

        <motion.div
          className="coming-soon-container"
        >
          <motion.h1
            initial={{ scale: 0.5, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.5, delay: 0.5, type: "spring", stiffness: 120 }}
          >
            Coming Soon
          </motion.h1>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.8 }}
          >
            We're working hard to bring you something amazing. Stay tuned!
          </motion.p>
        </motion.div>

        <motion.footer 
          className="page-footer"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 1.0, ease: "easeOut" }}
        >
          <p>
            Contact us: <a href="mailto:info@forwhiledo.com">info@forwhiledo.com</a>
          </p>
          <p>&copy; {currentYear} ForWhileDo™. All rights reserved.</p>
        </motion.footer>
      </motion.div>

      {isAboutVisible && (
        <motion.div
          className="about-modal-overlay"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={() => setIsAboutVisible(false)}
        >
          <motion.div
            className="about-modal-content"
            initial={{ scale: 0.8, opacity: 0, y: "-50px" }}
            animate={{ scale: 1, opacity: 1, y: "0px" }}
            exit={{ scale: 0.8, opacity: 0, y: "-50px" }}
            transition={{ type: "spring", stiffness: 300, damping: 30 }}
            onClick={(e) => e.stopPropagation()}
          >
            <p>
              FORWHILEDO creates modern digital experiences, including automation tools, 
              business apps, and interactive games for mobile and desktop platforms.
            </p>
            <button className="close-modal-button" onClick={() => setIsAboutVisible(false)}>
              Close
            </button>
          </motion.div>
        </motion.div>
      )}
    </div>
  );
}

export default App;
